module.exports = new __parcel__URL__("how-to.8bee216e.jpg").toString();